import { render, staticRenderFns } from "./parkvehicletyperule-form.vue?vue&type=template&id=0cc01778&scoped=true&"
import script from "./parkvehicletyperule-form.vue?vue&type=script&lang=js&"
export * from "./parkvehicletyperule-form.vue?vue&type=script&lang=js&"
import style0 from "./parkvehicletyperule-form.vue?vue&type=style&index=0&id=0cc01778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc01778",
  null
  
)

export default component.exports